import React, { useState, useContext } from "react";
import { PatientContext } from "../../lib/main-context";
import { useTranslation } from "../../i18n/TranslationProvider";

import { useHistory } from "react-router-dom";

import { useForm } from "react-hook-form";
import trackerSchema from "./validations/trackerSchema";
import { yupResolver } from "@hookform/resolvers";
import format from "date-fns/format";

import { Form, Row, Col, Alert } from "react-bootstrap";
import LabelledInput from "../UIComponents/LabelledInput";
import SubmitButton from "../UIComponents/SubmitButton";
import Spinner from "react-bootstrap/Spinner";

import { postAdditionalNote } from "../../api/TBIRequests";
import { signOut } from "../../api/auth";

const AdditionalNote = ({ date, user }) => {
  const history = useHistory();

  const { t } = useTranslation();
  const { patient } = useContext(PatientContext);

  const monthKeys = ["january","february","march","april","may_long","june",
    "july","august","september","october","november","december"];
  const tFormatDate = (date) => {
    if (!date) return "";
    const d = new Date(date);
    const month = t(`months.short.${["jan","feb","mar","apr","may","jun","jul","aug","sep","oct","nov","dec"][d.getMonth()]}`);
    return `${month} ${d.getDate()}, ${d.getFullYear()}`;
  };

  const [isSaving, setIsSaving] = useState(false);
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  const [show, setShow] = useState(false);

  const { register, handleSubmit, errors, reset, formState } = useForm({
    resolver: yupResolver(trackerSchema),
  });

  const onSubmit = (data) => {
    setIsSaving(true);
    data.date = date;
    postAdditionalNote({
      patientId: patient.patientId,
      therapistId: user.userType === "Therapist" ? user.userId : null,
      data,
    })
      .then(() => {
        reset();
        setIsSaving(false);
        setShow(true);
      })
      .catch((e) => console.log(e));
  };

  const handleFinishAndLogout = async () => {
    setIsLoggingOut(true);
    await signOut();
    history.go("/");
  };

  return (
    <>
      <h6 className="d-flex justify-content-between">
        <span>
          {patient.userPatientRelationshipType == "self"
            ? t("tracksymptom.patient")
            : t("tracksymptom.non_patient.0") +
              patient.firstName +
              t("tracksymptom.non_patient.1")}
        </span>
        <span>{tFormatDate(date)}</span>
      </h6>
      <Form onSubmit={handleSubmit(onSubmit)}>
        {show && !formState.isDirty ? (
          <Alert
            variant="success"
            onClose={() => {
              setShow(false);
            }}
            dismissible
          >
            {t("additionalnote.report_saved")}
          </Alert>
        ) : null}
        <Col>
          <LabelledInput
            required
            label={t("additionalnote.anything_else")}
            name="describeSymptom"
            errors={errors}
            inputRef={register}
            inputAs="textarea"
            rows={3}
          />
        </Col>
        <Row
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            margin: "-1rem 1rem 0rem 1rem",
          }}
        >
          <h6
            style={{
              borderRadius: "25px",
              backgroundColor: "#ef5866",
              color: "white",
              textAlign: "center",
              overflowWrap: "break-word",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "0.55rem 1.5rem",
              margin: "0",
            }}
            disabled={isLoggingOut}
            onClick={handleFinishAndLogout}
          >
            {isLoggingOut ? (
              <>
                <Spinner animation="border" size="sm" role="status" />
                {t("additionalnote.logging_out")}
              </>
            ) : (
              t("additionalnote.finish_and_logout")
            )}
          </h6>

          <SubmitButton type="submit" disabled={isSaving}>
            {t("additionalnote.save")}
          </SubmitButton>
        </Row>
      </Form>
    </>
  );
};

export default AdditionalNote;